import { searchPage } from '@backstage/plugin-search/alpha';
import { SearchContextProvider } from '@backstage/plugin-search-react';

// Override only the loader of the default search page from
// @backstage/plugin-search/alpha. Everything else — the `/search` path and,
// crucially, the `routeRef` bound to the search plugin's root route — is
// inherited from the original extension. That binding is what gives
// `search.root` a path; without it <SidebarSearchModal> throws
// "No path for routeRef{id=search.root,legacyId=search}".
//
// The custom SearchPage uses `useSearch`, so it must be wrapped in a
// SearchContextProvider (the legacy plugin's <SearchPage> wrapper provided this).
export const searchPageOverride = searchPage.override({
  params: {
    loader: () =>
      import('../../components/search/SearchPage').then(m => (
        <SearchContextProvider>{m.searchPage}</SearchContextProvider>
      )),
  },
});
